<template>
  <v-container fluid style="padding: 55px 35px 40px 35px">
    <v-card v-if="isReady" class="background-petty-cash-card" v-resize="onResize">
      <v-card-title class="pa-0 mb-5">
        <v-row no-gutters class="font-theme standard-row pb-7" align="center" justify="space-between">
          <v-col md="auto" lg="auto">
            <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
              <v-slide-item v-slot="{ active, toggle }" value="">
                <v-btn active-class="select-header-petty-cash-tabs" class="font-for-header-petty-cash-tabs" height="52"
                  :input-value="active" depressed rounded text @click="toggle">
                  All
                </v-btn>
              </v-slide-item>
              <v-slide-item v-for="(permissionPetty) in pettyCashPermissionTab" :key="permissionPetty" v-slot="{ active, toggle }" :value="permissionPetty">
                <v-btn active-class="select-header-petty-cash-tabs" class="font-for-header-petty-cash-tabs" height="52"
                  :input-value="active" depressed rounded text @click="toggle">
                  {{ permissionPetty }}
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </v-col>
          <v-col md="auto" lg="" v-if="windowSize.x >= 640">
            <span class="d-flex mt-5 mt-sm-0 justify-end">
              <v-btn rounded color="#0B68D6" class="white--text text-center download-report-inbox-btn" @click="goToDownloadReport()" height="53" width="193" style="font-weight: 700; font-size: 15px;">
                Download Report
              </v-btn>
            </span>
          </v-col>
          <v-col cols="1" sm="1" v-if="windowSize.x < 640" class="d-flex justify-end">
            <template>
              <v-menu offset-y v-if="permissionTabs !== 0">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" color="#414040">
                    <v-icon size="30">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list style="background-color: #414040">
                  <!-- <v-list-item dense @click="toSavePettyCashDialogSelected" :disabled="selected.length === 0">
                    <v-list-item-content>
                      <v-list-item-title class="font-theme white--text"
                        style="font-size: 16px; line-height: 25px">ตัดงบ</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <v-list-item dense @click="goToDownloadReport()">
                    <v-list-item-content>
                      <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" align="center">
          <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px; font-weight: 700"
            class="ml-4 ml-sm-0">
            ค้นหาเลขที่เอกสาร
          </v-col>
          <v-col cols="" sm="4" md="4" lg="4" class="ml-2">
            <v-text-field v-if="windowSize.x > 960" dense outlined hide-details color="black" background-color="white"
              v-model="holdKeyword" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)" @input="!holdKeyword ? checkRowsAndPageBeforeSearch(holdKeyword) : ''" height="42" class="font-theme petty-cash-text-field">
            </v-text-field>
            <v-text-field v-else dense outlined hide-details color="black" background-color="white" height="42"
              v-model="holdKeyword" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)" @input="!holdKeyword ? checkRowsAndPageBeforeSearch(holdKeyword) : ''" class="pt-3 font-theme custom-search-text-field">
              <template v-slot:append v-if="windowSize.x < 960"> 
                <v-btn icon style="margin-top: 3px">
                  <v-icon size="38" @click="checkRowsAndPageBeforeSearch(holdKeyword)">mdi-magnify</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col sm="auto" md="auto" lg="auto" class="ml-2">
            <v-btn v-if="windowSize.x >= 960" rounded color="#0B68D6" class="white--text" height="42" width="125"
              @click="checkRowsAndPageBeforeSearch(holdKeyword)"
              style="font-weight: 700; font-size: 15px; box-shadow: none">
              ค้นหา
            </v-btn>
            <v-select v-if="windowSize.x < 960" :items="statusDocument" hide-details outlined dense height="42" item-text="status"
            item-value="value" v-model="documentStatus" append-icon="mdi-chevron-down" background-color="white"
            item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }"
            class="custom-search-dropdown pt-3">
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title class="font-theme" style="font-size: 12px; font-weight: 700; line-height: 30px;">
                  {{data.item.status }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
          </v-col>
        </v-row>
      </v-card-title>
      <v-row no-gutters class="standard-row font-theme" align="center">
        <v-col cols="11" sm="11" md="auto" lg="auto" class="mt-2">
          <v-btn v-if="windowSize.x >= 980 && permissionTabs !== ''" class="font-theme btn-select-all" :disabled="isSaveBudget.length === 0" style="font-size: 12px;" @click="toggleSelectAll">
            <v-checkbox :class="isSaveBudget.length === 0 ? 'disabled-checkbox' : 'checkbox-select-all'" v-model="selectAll" disabled></v-checkbox>เลือกทั้งหมด
          </v-btn>
        </v-col>
        <v-col cols="11" sm="11" md="auto" lg="auto" class="ml-2 mt-2">
          <v-slide-group v-if="windowSize.x > 600" show-arrows mandatory v-model="documentStatus">
            <v-slide-item v-slot="{ active, toggle }" value="">
              <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                @click="toggle" height="41" depressed rounded text>
                <v-badge inline color="#3B639F" :content="countIsSaveBudget[''].toString()"
                  style="font-weight: 700; font-size: 12px;" class="cut-petty-badge-content">
                  เอกสารทั้งหมด
                </v-badge>
              </v-btn>
            </v-slide-item>
            <v-slide-item v-slot="{ active, toggle }" value="บันทึกงบสำเร็จ">
              <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                @click="toggle" height="41" depressed rounded text>
                <v-badge inline color="#08aa0e" :content="countIsSaveBudget['บันทึกงบสำเร็จ'].toString()"
                  style="font-weight: 700; font-size: 12px;" class="cut-petty-badge-content">
                  บันทึกงบสําเร็จ
                </v-badge>
              </v-btn>
            </v-slide-item>
            <v-slide-item v-slot="{ active, toggle }" value="ยังไม่บันทึกงบ">
              <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                @click="toggle" height="41" depressed rounded text>
                <v-badge inline color="#eb1f1f" :content="countIsSaveBudget['ยังไม่บันทึกงบ'].toString()"
                  style="font-weight: 700; font-size: 12px;" class="cut-petty-badge-content">
                  ยังไม่บันทึกงบ
                </v-badge>
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-col>
        <v-col v-if="windowSize.x > 600 && permissionTabs !== ''" sm="auto" md="auto" lg="auto" class="ml-2 mt-2"
          style="font-size: 12px; font-weight: 700">
          <v-icon color="#000000">mdi-clipboard-plus-outline</v-icon>
          เลือกเอกสารอยู่
          <v-badge inline color="#7FE0DA" :content="selected.length.toString()" class="cut-petty-badge-content pr-2">
         </v-badge>
          รายการ
        </v-col>
        <v-col v-if="windowSize.x < 600 && permissionTabs !== ''" class="mt-2" sm="auto" md="auto"  lg="auto"
          style="font-size: 12px; font-weight: 700; padding-top: 15px; padding-bottom: 5px;">
          <v-icon color="#000000">mdi-clipboard-plus-outline</v-icon>
          เลือกเอกสารอยู่
          <v-badge align="center" inline color="#7FE0DA" :content="selected.length.toString()" class="cut-petty-badge-content">
         </v-badge>
          รายการ
        </v-col>
        <v-col class="mt-2" align="end" style="font-size: 12px; font-weight: 700;"
          v-if="windowSize.x >= 980  && permissionTabs !== ''">
          <v-btn @click="toSavePettyCashDialogSelected" :disabled="selected.length === 0" style="font-size: 12px;"
            class="font-theme btn-select-all">
            <v-icon color="#000000" style="padding: 5px;">
              mdi-square-edit-outline
            </v-icon>
            ตัดงบ</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="standard-row font-theme mt-5" align="center">
        <v-col cols="6" sm="6" md="6" lg="6" class="" align="start">
           <v-btn v-if="windowSize.x < 980 && permissionTabs !== ''" class="font-theme btn-select-all" :disabled="isSaveBudget.length === 0" style="font-size: 6px;" @click="toggleSelectAll">
            <v-checkbox :class="isSaveBudget.length === 0 ? 'disabled-checkbox' : 'checkbox-select-all'" v-model="selectAll" disabled></v-checkbox>เลือกทั้งหมด
          </v-btn>
        </v-col>
         <v-col cols="6" sm="6" md="6" lg="6" class="" align="end">
          <v-btn v-if="windowSize.x < 980 && permissionTabs !== ''" @click="toSavePettyCashDialogSelected" :disabled="selected.length === 0" style="font-size: 12px;"
            class="font-theme btn-select-all">
            <v-icon color="#000000" style="padding: 5px;">
              mdi-square-edit-outline
            </v-icon>
            ตัดงบ</v-btn>
        </v-col>
      </v-row>
      <v-data-table :headers="headers" range :items="myItem" :options.sync="optionsDataTable"
        :server-items-length="countIsSaveBudget[documentStatus]" class="petty-cash-data-table pt-3" fixed-header
        :footer-props="{'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า',}">
        <template v-if="permissionTabs !== ''" v-slot:[`item.select`]="{ item }">
          <v-checkbox v-if="item.is_save_budget === 'ยังไม่บันทึกงบ' && callApiPending === 0" v-model="selected"
            :value="item" class="checkbox-select-all" style="margin-right: 8px">
          </v-checkbox>
        </template>
        <template v-slot:[`item.is_save_budget`]="{ item }">
          <span v-if="item.is_save_budget == 'บันทึกงบสำเร็จ'" style="color: #08aa0e"><v-icon color="#08aa0e">mdi-circle-medium</v-icon>บันทึกงบสําเร็จ</span>
          <span v-if="item.is_save_budget == 'ยังไม่บันทึกงบ'" style="color: #eb1f1f"><v-icon color="#eb1f1f">mdi-circle-medium</v-icon>ยังไม่บันทึกงบ</span>
        </template>
        <template slot="no-data">
          <v-alert class="text-center d-flex justify-center">
            ไม่พบข้อมูล
          </v-alert>
        </template>
        <template v-slot:footer.page-text="items">
          {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
        </template>
      </v-data-table>
    </v-card>
    <SavePettyCash ref="SavePettyCashDialog" />
    <DownloadReportModal />
  </v-container>
</template>
<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import SavePettyCash from "../components/SavePettyCashModal.vue";
import DownloadReportModal from '../components/DownloadReportModal.vue'
export default {
  components: {
    SavePettyCash,
    DownloadReportModal,
  },
  data: () => ({
    isReady:false,
    windowSize: { x: 0, y: 0 },
    optionsDataTable: { page: 1, itemsPerPage: 20 },
    countItem: 0,
    countIsSaveBudget: '',
    documentStatus: '',
    selected: [],
    myItem: [],
    selectAll: false,
    permissionTabs: '',
    statusDocument: [
      { status: 'เอกสารทั้งหมด', value: '' },
      { status: 'บันทึกงบสำเร็จ', value: 'บันทึกงบสำเร็จ' },
      { status: 'ยังไม่บันทึกงบ', value: 'ยังไม่บันทึกงบ' },
    ],
    headers: [
      {
        text: "",
        value: "select",
        align: "center",
        sortable: false,
        width: "70px",
      },
      {
        text: "เลขที่เอกสาร",
        value: "document_id",
        align: "center",
        sortable: false,
        width: "120px",
      },
      {
        text: "ผู้ส่งเอกสาร",
        value: "owner",
        align: "center",
        sortable: false,
        width: "160px",
      },
      {
        text: "ยอดเงิน",
        value: "total_amount",
        sortable: false,
        align: "center",
        width: "120px",
      },
      {
        text: "WorkFlow",
        value: "work_flow",
        align: "center",
        sortable: false,
        width: "210px",
      },
      {
        text: "Department",
        value: "department",
        align: "center",
        sortable: false,
        width: "180px",
      },
      {
        text: "Description",
        value: "description",
        sortable: false,
        align: "center",
        width: "180px",
      },
      {
        text: "Detail",
        value: "detail",
        sortable: false,
        align: "center",
        width: "180px",
      },
      {
        text: "วันที่ส่งเอกสาร",
        value: "send_doc_dwf",
        align: "center",
        sortable: false,
        width: "180px",
      },
      {
        text: "วันที่อนุมัติเอกสาร",
        value: "approve_dwf",
        align: "center",
        sortable: false,
        width: "180px",
      },
      {
        text: "วันที่บันทึกงบ",
        value: "updated_at",
        align: "center",
        sortable: false,
        width: "180px",
      },
      {
        text: "สถานะ",
        value: "is_save_budget",
        align: "center",
        sortable: false,
        width: "180px",
      },
    ],
    save_budget:'',
    isSaveBudget:'',
    headersTable: [],
    holdKeyword: '',
    callApiPending: 0,
  }),
  watch: {
    selected(newValue) {
      const newValueBudgets = newValue.length === 0 ? null : newValue.filter(e => e.is_save_budget === 'ยังไม่บันทึกงบ').length;
      const myItemBudgets = this.myItem.filter(e => e.is_save_budget === 'ยังไม่บันทึกงบ').length;
      if (newValueBudgets === myItemBudgets) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    myItem(newValue){
      this.isSaveBudget = newValue.filter(e => e.is_save_budget === 'ยังไม่บันทึกงบ');
    },
    "optionsDataTable.page"() {
      this.getAllItem();
      this.selectAll = false;
      this.selected = [];
    },
    "optionsDataTable.itemsPerPage"() {
      this.getAllItem();
      this.selected = [];
      this.selectAll = false;
    },
    "permissionTabs"() {
      this.holdKeyword = ''
      this.document_id = ''
      this.optionsDataTable.page = 1 
      this.getAllItem();
      this.selectAll = false;
    },
    "documentStatus"(val) {
      if (val === 'บันทึกงบสำเร็จ') {
        this.save_budget = true;
      } else if (val === 'ยังไม่บันทึกงบ') {
        this.save_budget = false;
      } else {
        this.save_budget = '';
      }
      this.optionsDataTable.page = 1
      this.getAllItem();
      this.selectAll = false;
    },
    "callApiPending"(val) {
      if (val > 0) {
        EventBus.$emit('loadingState', true)
      } else {
        EventBus.$emit('loadingState', false)
      }
      this.selected = [];
      this.selectAll = false;
    }
  },
  computed: {
    pettyCashPermissionTab() {
      return this.$store.state.pettyCashPermissionTab
    },
    pettyCashPermission() {
      return this.$store.getters.pettyCashPermission
    },
    selectedBiz() {
      return this.$store.state.confirmSelectedBiz
    },
  },
  mounted() {
    if (this.pettyCashPermission === true) {
      this.getAllItem();
      this.onResize();
      EventBus.$on('toCutPettyCashModal', this.resetPage);
    } else {
      return this.alert('ไม่มีสิทธิ์การเข้า', 'Warning', 'warning')
    }
  },
  beforeDestroy() {
    EventBus.$off('toCutPettyCashModal');
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth };
    },
    checkRowsAndPageBeforeSearch(params) {
      this.document_id === params
      this.document_id = params.trim()
      this.checkPageForGetTransaction()
    },
    checkPageForGetTransaction() {
      if (this.optionsDataTable.page === 1) {
        this.getAllItem()
      } else {
        this.optionsDataTable.page = 1
      }
    },
    select_All() {
      if (this.selectAll) {
        this.selected = this.myItem.filter(e => e.is_save_budget === 'ยังไม่บันทึกงบ');
      } else {
        this.selectAll = false;
        this.selected = [];
      }
    },
    toSavePettyCashDialogSelected() {
      var selectedToSave = [...this.selected]
      EventBus.$emit('toSavePetty', selectedToSave);
    },

    async getAllItem() {
      this.callApiPending++
      const searchTransactions = {
        baseURL: this.$api_url,
        url: `/petty_cash/api/v1/search_petty_cash?&document_id=${this.document_id || ''}&offset=${(this.optionsDataTable.page - 1) * this.optionsDataTable.itemsPerPage || 0}&limit=${this.optionsDataTable.itemsPerPage}&budget_type=${this.permissionTabs || ''}&save_budget=${this.save_budget}&tax_id=${this.selectedBiz.tax_id || ''}`,
        method: 'GET'
      }
      await Promise.all([this.axios(searchTransactions)]).then(values => {
        this.countItem = values[0].data.count
        values[0].data.data.forEach((item) => {
          item.item.forEach(e => {
            e.amount = MainFunction.addComma(parseFloat(e.amount).toFixed(2) || '0.00');
          });
          item.total_amount = MainFunction.addComma(item.total_amount) || '0.00';
          item.send_doc_dwf = MainFunction.fullDateThTime(item.send_doc_dwf) || '-';
          item.approve_dwf = MainFunction.fullDateThTime(item.approve_dwf) || '-';
          item.updated_at = MainFunction.fullDateThTime(item.updated_at) || '-';
        });
        this.myItem = values[0].data.data
        this.countIsSaveBudget = {
          '': values[0].data.count || 0,
          'บันทึกงบสำเร็จ': values[0].data.count_save_budget      || 0,
          'ยังไม่บันทึกงบ': values[0].data.count_not_save_budget || 0,
        }
        $(".petty-cash-data-table.v-data-table > .v-data-table__wrapper").scrollTop(0);

      }).catch(error => {
        this.myItem = []
        this.countItem = 0
        this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
        console.log(error)
      }).finally(() => {
        this.isReady = true
        this.callApiPending--
        this.trigRowPerPage = false
      })
    },
    toggleSelectAll() {
      if(this.selectAll){
        this.selectAll = false
      }else{
        this.selectAll = true
      }
      this.select_All();
  },
    resetPage() {
      location.reload();
    },
    goToDownloadReport(){
      const aboutReport = {
        url        : '/petty_cash/api/v1/report_petty_cash',
        permission : this.permissionTabs,
        from       : 'cut_petty_cash'
      }
      EventBus.$emit('openDownloadReportModal', aboutReport)
    },
      alert(title = '', text = 'Warning', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
  },
  
};
</script>
<style>
.background-petty-cash-card {
  border-radius: 23px !important;
  background: #f1f1f1;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.25);
  padding: 30px;
  max-width: 100%;
}

.btn-select-all {
  background-color: #D9D9D9;
  margin-bottom: 0px;
  border-radius: 12px;
  border: 1px solid #000000;
  color: #000000;
}

.checkbox-select-all {
  padding-left: 3px;
}

.checkbox-select-all .v-input__slot>.v-label {
  font-size: 12px;
  color: black;
}

.checkbox-select-all :before,
::after {
  text-decoration: inherit;
  vertical-align: inherit;
  color: black;
}
.disabled-checkbox{
  padding-left: 3px;
}

.disabled-checkbox .v-input__slot > .v-label {
  
  color: #d2d1d180; /* Style when disabled */
}

.btn-select-all:not(.v-btn--round).v-size--default {
  padding: 0 10px 0 2px;
}

.petty-cash-text-field {
  border-radius: 30px !important;
}

.petty-cash-text-field.v-text-field--outlined fieldset {
  border-color: black !important;
}

.select-header-petty-cash-tabs {
  background: #d2d1d180 !important;
  color: black !important;
}

.font-for-header-petty-cash-tabs {
  font-family: 'Sarabun', sans-serif;
  font-size: calc(100% + 0.56vw) !important;
  font-weight: 700;
  letter-spacing: 2px;
  color: #8D8D8D !important;
}

.font-for-header-petty-cash-tabs:before {
  background: transparent !important;
}

.petty-cash-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-left: 5px;
  margin-right: 5px;
}

.petty-cash-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  line-height: 30px;
}

.petty-cash-data-table {
  font-family: "Noto Sans Thai", sans-serif !important;
  border-radius: 10px;
}

.petty-cash-data-table .v-data-table__wrapper table .v-data-table-header tr th {
  background-color: #F1F0F0;
  color: #030303 !important;
  height: 56px;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
}

.petty-cash-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  color: #000000;
  font-size: 12px;
  font-weight: 700;
}

.petty-cash-data-table.v-data-table>.v-data-table__wrapper {
  height: calc(100vh - 174px);
  overflow: auto;
  scroll-behavior: smooth;
}

.petty-cash-data-table thead th:first-child {
  border-radius: 10px 0 0 0;
}

.petty-cash-data-table thead th:last-child {
  border-radius: 0 10px 0 0;
}

.petty-cash-data-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent !important;
}

.petty-cash-data-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: transparent !important;
}

.petty-cash-data-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #F7F6F6;
  ;
}

.font-for-header-petty-cash-tabs {
  font-family: 'Sarabun', sans-serif;
  font-size: calc(100% + 0.56vw) !important;
  font-weight: 900;
  letter-spacing: 2px;
  line-height: 43.57px;
  color: #8D8D8D !important;
}

.font-for-header-petty-cash-tabs:before {
  background: black !important;
}

.select-header-petty-cash-tabs {
  background: none !important;
  color: black !important;
}

.petty-cash-data-table .v-data-table__wrapper {
  height: calc(100vh - 210px);
  overflow: auto;
}

/* First Column */
.petty-cash-data-table .v-data-table__wrapper > table thead th:nth-child(1) {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 4;
    background-color: #F1F0F0;
}
.petty-cash-data-table .v-data-table__wrapper > table tbody tr td:nth-child(1) {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #fff;
}
.petty-cash-data-table .v-data-table__wrapper > table thead th:nth-child(2) {
    position: sticky;
    top: 0;
    left: 70px;
    z-index: 4;
    background-color: #F1F0F0;
}
.petty-cash-data-table .v-data-table__wrapper > table tbody tr td:nth-child(2) {
    position: sticky;
    top: 0;
    left: 70px;
    z-index: 1;
    background-color: #fff;
}
.petty-cash-data-table .v-data-table__wrapper > table thead th:nth-child(3) {
    position: sticky;
    top: 0;
    left: 190px;
    z-index: 4;
    background-color: #F1F0F0;
}
.petty-cash-data-table .v-data-table__wrapper > table tbody tr td:nth-child(3) {
    position: sticky;
    top: 0;
    left: 190px;
    z-index: 1;
    background-color: #fff;
}
.petty-cash-data-table .v-data-table__wrapper > table thead th:nth-child(4) {
    position: sticky;
    top: 0;
    left: 350px;
    z-index: 4;
    background-color: #F1F0F0;
}
.petty-cash-data-table .v-data-table__wrapper > table tbody tr td:nth-child(4) {
    position: sticky;
    top: 0;
    left: 350px;
    z-index: 1;
    background-color: #fff;
    box-shadow: 10px 0px 10px rgba(0, 0, 0, 0.04);
}
.petty-cash-data-table .v-data-table__wrapper > table thead th:nth-child(5) { 
    padding-left: 30px;
}
.petty-cash-data-table .v-data-table__wrapper > table tbody tr td:nth-child(5) {
    padding-left: 30px;
}
</style>
